<template>
  <InsightCard
    title="Top Spending Keywords"
    column1="Keyword"
    column2="Share"
    column3="Spend"
    apiUrl="/google-ads-insights/keyword-level-spends"
    :displayIndex="index"
    :formatter="formatNumber"
    :change="3"
    srcName="gads"
  />
</template>

<script setup>
import { formatNumber } from '@/utils/helperFunctions';
import InsightCard from '@/components/InsightCard.vue';

const index = [0, 1];
</script>
